// src/theme/foundations/semantic-radii.ts

/**
 * The shape hierarchy, by how large a surface is:
 *
 * - `l1` — small controls: buttons, badges, tags, tabs, segmented controls
 * - `l2` — inputs and mid-sized surfaces: stats, alerts
 * - `l3` — large surfaces: cards, dialogs, action bars
 *
 * The values currently match Chakra's own defaults, so the shape hierarchy is in
 * place without changing how the application looks. Deciding the SIB shapes is
 * design work of its own; changing them is one edit here and applies everywhere,
 * because the component recipes reference these tokens rather than raw radii.
 */
export const semanticRadii = {
  l1: { value: '{radii.xs}' },
  l2: { value: '{radii.sm}' },
  l3: { value: '{radii.md}' },
}
